import { NgClass } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';

import { IdentityModel } from '@core/models/identity.model';
import { AppStateService } from '@core/services/app-state.service';
import { select, Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';

import * as fromRoot from './core/redux/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterModule],
  styleUrls: ['./app.component.less'],
  providers: [NgClass, DeviceDetectorService],
  standalone: true,
})
export class AppComponent implements OnInit {
  private ngClass = inject(NgClass, { self: true });
  private store = inject<Store<fromRoot.State>>(Store);
  private deviceService = inject(DeviceDetectorService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);
  private appStateService = inject(AppStateService);

  userIdentity: IdentityModel;
  tg: any;

  constructor() {
    this.store
      .pipe(select(fromRoot.getUser), takeUntilDestroyed(this.destroyRef))
      .subscribe((user: IdentityModel) => (this.userIdentity = user));
  }

  initTelegramWebApp() {
    try {
      this.tg = (window as any).Telegram.WebApp;

      if (this.tg) {
        this.tg.ready();

        // this.tg.requestFullscreen();
        // this.tg.disableVerticalSwipes();
        this.tg.expand();

        // Подписываемся на событие изменения хэша в URL
        window.addEventListener('hashchange', () => {
          this.handleTelegramWebAppUrl();
        });

        // Обрабатываем начальный URL
        this.handleTelegramWebAppUrl();
      }
    } catch (e) {
      console.error('Telegram WebApp initialization error:', e);
    }
  }

  handleTelegramWebAppUrl() {
    const webAppUrl = this.tg.initDataUnsafe?.start_param;
    if (webAppUrl) {
      // Декодируем URL-параметр и навигируем к нужному роуту
      const decodedUrl = decodeURIComponent(webAppUrl);
      this.router.navigateByUrl(decodedUrl);
    }
  }

  private isPwaMode(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;
  }

  ngOnInit() {
    this.initTelegramWebApp();

    if (this.deviceService.os !== 'mac' && this.deviceService.os !== 'android') {
      this.ngClass.ngClass = 'no-mac';
    }

    // Проверяем, запущено ли приложение как PWA и есть ли сохраненный URL
    if (this.isPwaMode() && this.userIdentity) {
      const lastUrl = this.appStateService.getLastVisitedUrl();
      if (lastUrl && lastUrl !== this.router.url) {
        this.router.navigateByUrl(lastUrl);
      }
    }
  }
}
